import React, { createContext, useContext, useReducer, useEffect } from 'react'
import { saveState } from 'utils/localStorage'

export const StateContext = createContext()

const middleware = dispatch => event => dispatch(event)

export const StateProvider = ({ reducer, initialState, children }) => {
   const [state, dispatch] = useReducer(reducer, initialState)

   useEffect(() => saveState(state?.sessionUser), [state?.sessionUser])

   return (
      <StateContext.Provider value={[state, middleware(dispatch)]}>
         {children}
      </StateContext.Provider>
   )
}

export const useStateValue = () => useContext(StateContext)
